import React from "react";

type PreOrderTimeType = {
  subType?: string;
  time?: string;
};

const PreOrderTime = ({ subType, time }: PreOrderTimeType) => {
  return (
    <div className="BookingPreOrders-Time">
      {subType && (
        <div className="BookingPreOrders-TimeSubtype font-bold mb-panel-padding">
          {subType}
        </div>
      )}
      <div className="BookingPreOrders-TimeTime">{time ?? "— : —"}</div>
    </div>
  );
};

export default PreOrderTime;
